import { Pipe, PipeTransform } from '@angular/core';
import { getCompanyCorrelationFromCategory } from '@mwe/utils';

@Pipe({ name: 'correlatedCompanyReference', })
export class CorrelatedCompanyReferencePipe implements PipeTransform {
  transform(category: string): string {
    return getCompanyCorrelationFromCategory(category);
  }
}
